import styled from "styled-components";

export const Wrapper = styled.div<{ $disableBorder?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-bottom: 10px;

  border-bottom-color: rgba(0, 0, 0, 0.12);
  border-bottom-style: solid;
  border-bottom-width: ${({ $disableBorder = false }) =>
    $disableBorder ? "0" : "1px"};
`;

export const ContainerDriver = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ContainerDrive = styled.div<{ $hasDriver?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: ${({ $hasDriver = false }) => ($hasDriver ? "16px" : "8px")};
`;

export const ContainerDriverSelected = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
`;

export const DriverAvatarCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  background-color: #d33100;
  color: #ffffff;
  font-size: 12px;
  line-height: 1;
  font-weight: 400;
  font-family: Roboto, sans-serif;
  text-transform: uppercase;
`;

export const DriverDisplayName = styled.span`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #202224;
  font-family: Roboto, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ContainerAutoComplete = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerButtonsDrive = styled.div`
  display: flex;
  gap: 10px;
`;

export const Button = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
`;

export const ButtonAccept = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const ButtonBackDrive = styled.button`
  display: flex;
  background: none;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  height: 30px;
  border-radius: 15px;
  border: solid 1px rgba(0, 0, 0, 05);
  cursor: pointer;
`;

export const ButtonApplyDrive = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  padding: 8px 24px;
  background: #d33100;
  height: 30px;
  border-radius: 15px;
  border: solid 1px #d33100;
  cursor: pointer;
  color: #ffffff;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
